<script>
export default {
    name: "InvestigationLabRequest",

    data() {

        return {
            investigation: {},
            results: {},
            patient: {},
            admissionDetails: {},
            imageResults: [],
            printDate: window.moment()
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ 
                this.fetchComponentResults(), 
                this.fetchInvestigation(), this.fetchPatient(), 
            ]).then(() => {
                this.$root.loading=false;
                setTimeout(() => {
                    window.print();
                }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatientWithWard`;
                url += `?PatientID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(response => {
                this.patient = response.data.patientDetails.length ?
                     response.data.patientDetails[0] : {};
                this.admissionDetails = response.data.admissionDetails.length ? 
                    response.data.admissionDetails[0] : {};
            }).catch(() => {});
        },

        fetchComponentResults() {
            let url = `MedicalFile/GetOtherInvestigationComponentResults`;
                url += `?InvestigationID=${this.$route.params.labResultID}`

            return this.$http.get(url).then(response => {
                    this.results = response.data;
                }).catch(() => {});
        },

        
        fetchInvestigation() {
            let url = `MedicalFile/GetSpecificPatientOtherInvestigation`;
                url += `?PatientLabResultID=${this.$route.params.labResultID}`

            return this.$http.get(url).then(response => {
                this.investigation = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full text-center mt-4">
            <h5 class="text-base font-bold uppercase">Investigation Results</h5> 
        </div>
        <div class="w-full flex flex-wrap mt-2">
            <div class="w-full flex flex-wrap p-1 my-1 border-b-2 border-t-2 border-gray-800">
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">Name:</span> 
                        {{ patient.names }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">IP File No:</span> 
                    {{ patient.ipfileno || `-` }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">OP File No:</span> 
                    {{ patient.opfileno || `-` }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">Visit No:</span> 
                    {{ patient.visitNo || `-` }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">MRN:</span> 
                        {{ patient.patienT_ID }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">Age:</span> 
                        {{ patient.dob | numberOfYears }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">Gender:</span> 
                        {{ patient.gender }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">Ward:</span> 
                        {{ admissionDetails.ward || `-` }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">Bed:</span> 
                        {{ admissionDetails.bed || `-` }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">Request Date:</span> 
                        {{ investigation.selDate | dateFormat }}</h5>
                </div>
                <div class="w-1/4">
                    <h5 class="text-base"><span class="font-medium">Done Date:</span> 
                        {{ investigation.selDate | dateFormat }}</h5>
                </div>
                <!-- <div class="w-1/3">
                    <h5 class="text-base"><span class="font-medium">Printed On:</span> 
                        {{ printDate | dateFormatDT }}</h5>
                </div> -->
            </div>
            <div class="w-full flex flex-wrap p-1 my-1 border-b-2 border-gray-800">
                <div class="w-full">
                    <h5 class="text-base"><span class="font-medium">Investigation:</span> 
                        {{ investigation.itemName }}</h5>
                </div>
            </div>
            <div class="w-full overflow-auto my-2">
                <table class="table">
                    <tbody class="text-base overflow-visible">
                        <tr>
                            <th class="p-tiny">Component</th>
                            <th class="p-tiny">Value</th>
                            <th class="p-tiny">Min Value</th>
                            <th class="p-tiny">Max Value</th>
                            <th class="p-tiny">Unit</th>
                            <th class="p-tiny">Comment</th>
                            
                        </tr>
                    </tbody>
                    <tbody 
                        v-for="(result,idx) in results" :key="idx"
                        class="text-base overflow-visible">
                        <tr>
                            <td class="p-tiny">{{ result.component }}</td>
                            <td class="p-tiny">{{ result.resultValue }}</td>
                            <td class="p-tiny">{{ result.minValue }}</td>
                            <td class="p-tiny">{{ result.maxValue }}</td>
                            <td class="p-tiny">{{ result.description || `-` }}</td>
                            <td class="p-tiny">{{ result.comment || `-` }}</td>
                        </tr>
                        <tr>
                            <td colspan="6" class="p-tiny">
                               <!-- <span class="font-bold">Description: </span>  -->
                                <!-- {{ result.memo || `-` }} -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="w-full flex flex-wrap my-3">
                <div class="w-1/3">
                    <h5 class="text-base"><span class="font-medium">Requested By:</span> 
                        {{ investigation.clinician || `-` }}</h5>
                </div>
                <div class="w-1/3">
                    <h5 class="text-base"><span class="font-medium">Done By:</span> 
                        {{ investigation.doneBy || `-` }}</h5>
                </div>
                <div class="w-1/3">
                    <h5 class="text-base"><span class="font-medium">Reviewed By:</span> 
                        ............................</h5>
                </div>
            </div>
            <div class="w-full flex flex-col my-3">
                <div class="flex-1">
                    <h5 class="font-bold my-2">Request comment:</h5>
                    <span v-html="investigation.memo"></span>
                </div>
                <div class="flex-1">
                    <h5 class="font-bold my-2">Result memo</h5>
                    <span v-html="results.resultsMemo"></span>
                </div>
            </div>
            <tail-stamp></tail-stamp> </div>
    </div>
</template>
